import { Button, Typography } from '@mui/material';

import { MyLocation } from '@mui/icons-material';
import React from 'react';
import { useLocation } from 'react-ui-components/components/location/locationContext';
import { getLocationStr } from '../utils/locationFormat';
import { useNamespacedTranslation } from '../hooks/useNamespacedTranslation';

interface UserLocationButtonProps {
  style?: React.CSSProperties;
  textPosition?: string;
  iconColor?: any;
  iconStyle?: any;
  hideIcon?: boolean;
  color?: any;
  fullWidth?: boolean;
  onPress?: (location: any) => void;
  textButton?: boolean;
}

export const UserLocationButton = function (props: UserLocationButtonProps) {
  const {
    textPosition,
    iconStyle,
    hideIcon,
    color,
    fullWidth,
    textButton,
    onPress,
  } = props;

  const { currentLocation } = useLocation();

  const { t } = useNamespacedTranslation(['common']);

  const UserLocationButtonText = () => {
    const loc = { ...currentLocation };
    loc.country = t((loc.country || '-').toLowerCase());
    return <Typography fontSize="smaller">{getLocationStr(loc)}</Typography>;
  };

  return (
    <Button
      variant={textButton ? 'text' : 'contained'}
      color={color || 'success'}
      fullWidth={fullWidth}
      onClick={() => onPress && onPress(currentLocation)}
    >
      {textPosition !== 'RIGHT' && UserLocationButtonText()}
      {!hideIcon && <MyLocation style={iconStyle} />}
      {textPosition === 'RIGHT' && UserLocationButtonText()}
    </Button>
  );
};
